<template>
    <div>
        <sui-form-field v-for="key in Object.keys(input)" :key="key">
            <sui-form-field>
                <label>Output property</label>
                <div class="ui fluid action input">
                    <input type="text" :value="key" disabled>
                    <sui-button color="red">Remove</sui-button>
                </div>
            </sui-form-field>

            <sui-form-field v-for="(item, itemIndex) in input[key]" :key="itemIndex">
                <label v-if="itemIndex === 0">Fields</label>
                <div class="ui fluid action input">
                    <input type="text" v-model="input[key][itemIndex]" @input="onChange">
                    <sui-button color="red" @click="onRemoveItem(input[key], itemIndex)">Remove</sui-button>
                </div>
            </sui-form-field>

            <sui-form-field>
                <sui-button fluid @click="onAddItem(input[key], '')">Add</sui-button>
            </sui-form-field>
        </sui-form-field>

        <sui-form-field>
            <label>New output property</label>
            <div class="ui fluid action input">
                <input type="text" v-model="newKey">
                <sui-button @click="onAddKey(input, newKey, [''])">Add</sui-button>
            </div>
        </sui-form-field>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            input: this.value,
            newKey: '',
        };
    },
    watch: {
        value: {
            handler(value) {
                this.input = value;
            },
            immediate: true,
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.input);
        },
        onAddItem(array, value) {
            array.push(value);
            this.onChange();
        },
        onRemoveItem(array, index) {
            array.splice(index, 1);
            this.onChange();
        },
        onAddKey(object, key, value) {
            this.$set(object, key, value);
            this.newKey = '';
            this.onChange();
        },
    }
}
</script>